<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
};
</script>

<template>
  <content-loader
    width="972"
    height="365"
    viewBox="0 0 972 365"
    :speed="2"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="68" y="199" width="787" height="25" rx="4" />
    <rect x="68" y="234" width="787" height="25" rx="4" />
    <rect x="68" y="269" width="787" height="25" rx="4" />
    <rect x="68" y="304" width="787" height="25" rx="4" />
    <rect x="68" y="58" width="151" height="83" rx="4" />
    <rect x="386" y="59" width="151" height="83" rx="4" />
    <rect x="704" y="60" width="151" height="83" rx="4" />
    <rect x="67" y="151" width="152" height="20" rx="4" />
    <rect x="67" y="28" width="152" height="20" rx="4" />
    <rect x="385" y="152" width="152" height="20" rx="4" />
    <rect x="385" y="29" width="152" height="20" rx="4" />
    <rect x="703" y="30" width="152" height="20" rx="4" />
    <rect x="703" y="153" width="152" height="20" rx="4" />
  </content-loader>
</template>
